import React from "react";
import {View, Text, TouchableOpacity, StyleSheet, Modal, Dimensions, ScrollView} from "react-native";
import {RFValue} from "react-native-responsive-fontsize";
import {FontAwesome} from "@expo/vector-icons";
import AsyncStorage from "@react-native-async-storage/async-storage";
import axios from "axios";
import Config from "../../Config";
import Toast from "./Toast";
import Entypo from '@expo/vector-icons/Entypo';
import * as Speech from "expo-speech";
const {height} = Dimensions.get("window");
import Ionicons from '@expo/vector-icons/Ionicons';
import toast from "./Toast";


const WordSplitter = ({ text, video ,lesson_id}) => {
    const safeText = typeof text === "string" ? text : "";
    const words = safeText.split(" ");

    const [showModal, setShowModal] = React.useState(false);
    const [currentword, setCurrentword] = React.useState("");

    let [data, setData] = React.useState(false);
    let [saved, setSaved] = React.useState(false);

    const showaidictionary = async (word) => {
       setSaved(false);
        setData(false);
        if (video?.current?.pauseAsync) video.current.pauseAsync();
        setShowModal(true);
        setCurrentword(word);
        //
        await getData(word);
    };

    let getData = async (wrd) => {
        try {
            let token = await AsyncStorage.getItem('token');
            // let res = await axios.get(`${Config.api}/user/aidictionary2?word=${wrd}`, {'headers': {Authorization: 'Bearer ' + token}});
            let res = await axios.get(`https://gemini.karzanins.ir/gemini.php?word=${wrd}`, {'headers': {Authorization: 'Bearer ' + token}});
            console.log(res.data);
            if (res.data.code != 1) {
                Toast(res.data.error);
            }else{

                setData(res.data);
            }





        } catch (err) {
            console.log(err);
            alert('خطا')
        }
    }
    const speak = (thingToSay) => {

        // const thingToSay = 'The subject of the sentence is The cat  ';
        Speech.speak(thingToSay, {
            pitch: 1.1,        // تُن صدا
            rate: 0.6,         // سرعت گفتار (۰.۱ تا ۲.۰)
        });
    };


    const saveflashcart = async () => {

        try {
            let token = await AsyncStorage.getItem('token');


            let formData = new FormData();
            formData.append('lesson_id', lesson_id);
            formData.append('word', currentword);
            formData.append('data', JSON.stringify(data));


            let resss = await axios.post(
                `${Config.api}/user/saveflashcart`,
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                        "Authorization": 'Bearer '+token
                    }
                }
            );

            console.log(resss.data);

            if(resss.data.code != 1){
                // alert(JSON.stringify(res.data));
                // console.log(res.data.data);
                Toast(resss.data.error);
            }
            toast('فلش کارت ذخیره شد .');
            setSaved(true);
        } catch (err) {
            console.log(err);
            alert('خطا')
        }
    }




    return (
        <View style={styles.container}>

            {words[0].length > 0 &&
                <Text style={styles.wordText}>▶︎</Text>
            }

            {words.map((word, index) => (
                <>
                    <TouchableOpacity key={index} onPress={() => showaidictionary(word)} style={styles.wordBtn}>
                        <Text style={styles.wordText}>{word}</Text>
                    </TouchableOpacity>
                </>


            ))}

            <Modal
                animationType="slide"
                transparent={true}
                visible={showModal}
                onRequestClose={() => setShowModal(false)}
            >
                {/* پس‌زمینه نیمه‌شفاف */}
                <View style={styles.modalOverlay} >
                    {/* جعبه پایین صفحه */}
                    <View style={styles.modalContent}>
                        <Text style={styles.title}>{currentword}</Text>
                        <FontAwesome onPress={()=>setShowModal(false)} style={{position : 'absolute' , left : 20, zIndex : 10 , top : 20}} name="close" size={28} color="red" />

                        {data &&
                            <>
                                {saved ?
                                    <Ionicons name="bookmark" style={{position : 'absolute' , right : 20, zIndex : 10 , top : 20}} size={28} color={Config.maincolor} />
                                    :
                                    <Ionicons onPress={saveflashcart} name="bookmark-outline" style={{position : 'absolute' , right : 20, zIndex : 10 , top : 20}} size={28} color={Config.maincolor} />
                                }

                            </>
                        }


                        <ScrollView style={styles.modalContent}>
                            {data ?
                               <>
                                   <View style={styles.rowai}>
                                       <Text style={styles.typetext}>نوع کلمه :</Text>
                                       <Text style={styles.resulttext2}>
                                           {data.type}
                                       </Text>
                                   </View>
                                   <View style={styles.rowai}>
                                       <Text style={styles.typetext}>تلفط کلمه :</Text>
                                       <Text style={styles.resulttext2}>
                                           {data.phonetic}
                                       </Text>
                                   </View>
                                   <View style={styles.rowai2}>
                                       <Text style={styles.typetext}> معنی فارسی  :</Text>
                                   </View>
                                   {data.meaning_fa.map((item,index) =>
                                       <View key={index} >
                                           <Text  style={styles.texten}>
                                               {index + 1} -
                                               {item}
                                           </Text>
                                       </View>
                                   )}
                                   <View style={styles.rowai2}>
                                       <Text style={styles.typetext}>   مثال های ساده   :</Text>
                                   </View>
                                   {data.simple_example.map((item, index) =>
                                       <View key={index} style={styles.box}>
                                           <View  style={styles.rowai2}>
                                               <Entypo onPress={()=>speak(item.en)} name="controller-play" style={{padding : RFValue(5)}} size={RFValue(20)} color={Config.secondcolor} />
                                               <Text style={styles.texten}>
                                                   {item.en}
                                               </Text>
                                           </View>
                                           <View  style={styles.rowai2}>
                                               <Text style={styles.textfa}>
                                                   {item.fa}
                                               </Text>
                                           </View>
                                       </View>
                                   )}


                                   <View style={styles.rowai2}>
                                       <Text style={styles.typetext}>   مثال های سطح بالا   :</Text>
                                   </View>
                                   {data.advanced_example.map((item, index) =>
                                       <View key={index} style={styles.box}>
                                           <View  style={styles.rowai2}>
                                               <Entypo onPress={()=>speak(item.en)} name="controller-play" style={{padding : RFValue(5)}} size={RFValue(20)} color={Config.secondcolor} />
                                               <Text style={styles.texten}>
                                                   {item.en}
                                               </Text>
                                           </View>
                                           <View  style={styles.rowai2}>
                                               <Text style={styles.textfa}>
                                                   {item.fa}
                                               </Text>
                                           </View>
                                       </View>
                                   )}

                                   <View style={styles.rowai2}>
                                       <Text style={styles.typetext}>   نکته های آموزشی </Text>
                                   </View>

                                   <View style={styles.rowai}>
                                       <Text style={styles.typetext}>  هم معنی ها  :</Text>
                                       <Text style={styles.resulttext2}>
                                           {data.synonyms}
                                       </Text>
                                   </View>
                                   <View style={styles.rowai}>
                                       <Text style={styles.typetext}>  متصاد ها    :</Text>
                                       <Text style={styles.resulttext2}>
                                           {data.antonyms}
                                       </Text>
                                   </View>
                                   <View style={styles.rowai}>

                                       <Text style={styles.resulttext2}>
                                           {data.common_mistake}
                                       </Text>
                                   </View>


                                   <View style={styles.rowai2}>
                                       <Text style={styles.typetext}>  ترکیب های مفید  :</Text>
                                   </View>
                                   {data.useful_collocations.map((item,index) =>
                                       <View key={index} >
                                           <Text  style={styles.textfa}>
                                               {index + 1} -
                                               {item}
                                           </Text>
                                       </View>
                                   )}



                                   <View style={{marginBottom : RFValue(40)}}></View>

                               </>
                                :
                                <Text style={styles.loading}>در حال ترجمه با دیکشنری هوش مصنوعی ....</Text>
                            }
                        </ScrollView>
                    </View>
                </View>
            </Modal>
        </View>
    );
};

const styles = StyleSheet.create({
    container: {
        flexDirection: "row-reverse",
        flexWrap: "wrap",
        gap: 4,
        padding: 5,
        backgroundColor : '#0d1112',
        marginHorizontal: RFValue(10),
        borderRadius: RFValue(5),
        width : Dimensions.get("window").width - RFValue(20),
        justifyContent : 'center',
    },
    wordBtn: {
        // backgroundColor: "#f2f2f2",
        // backgroundColor: "red",
        paddingHorizontal: 4,
        paddingVertical: 2,
        borderRadius: 8,
    },
    wordText: {
        color: "whitesmoke",
        fontSize: 16,
        fontWeight: "bold",
        fontFamily: "ykb",
    },
    modalOverlay: {
        flex: 1,
        justifyContent: "flex-end", // مودال در پایین قرار بگیرد
        backgroundColor: "rgba(0,0,0,0.3)", // پس‌زمینه نیمه‌شفاف
    },
    modalContent: {
        height: height * 0.70, // ۵۰ درصد ارتفاع صفحه
        backgroundColor: "#fff",
        borderTopLeftRadius: 20,
        borderTopRightRadius: 20,
        paddingVertical: RFValue(40),
        paddingHorizontal: RFValue(10),
    },
    closeBtn: {
        backgroundColor: "red",
        padding: 10,
        borderRadius: 10,
        alignSelf: "center",
        marginTop: 20,
    },
    loading: {
        textAlign: "center",
        fontFamily : 'yk',
        fontSize: RFValue(12),
        paddingVertical : RFValue(20),
    },
    typetext: {
        textAlign: "center",
        fontFamily : 'ykb',
        fontSize: RFValue(12),

    },
    title: {
        textAlign: "center",
        fontFamily : 'ykb',
        fontSize: RFValue(18),
        color : Config.maincolor,

    },
    texten: {
        textAlign: "left",
        fontFamily : 'yk',
        fontSize: RFValue(14),
        color: Config.maincolor,
        maxWidth : '90%'
    },
    textfa: {
        textAlign: "right",
        fontFamily : 'yk',
        fontSize: RFValue(12),
        maxWidth : '90%'
    },
    resulttext: {
        textAlign: "center",
        fontFamily : 'yk',
    },
    rowai : {
        flexDirection: "row",
        justifyContent: "space-between",
        borderBottomColor : "#f2f2f2",
        borderBottomWidth: 1,
        paddingVertical: RFValue(5),
        marginBottom: RFValue(5),
    },

    rowai2 : {
        flexDirection: "row",
        justifyContent: "space-between",

        paddingVertical: RFValue(5),
        marginBottom: RFValue(5),
    },
    box : {
        borderWidth : 1,
        borderColor : "#f2f2f2",
        borderRadius : RFValue(20),
        paddingHorizontal : RFValue(10),
        marginTop: RFValue(10),
    }
});

export default WordSplitter;
